import { buildServerSideContext, buildServerSideProps } from '@/utils/buildServerSide'
import baseRouter from '@/utils/baseRouter'

import { getFaqsList } from '@/services/content/getFaqsList'
import { getPrismicRef } from '@/utils/prismicPreview'

import FinancingView from '@/views/Financing'

const router = baseRouter().get(async (req, res) => {
    const pageData = {
        title: 'Financing | Saatva',
        description: 'Shop now, pay later for your Saatva mattress. Learn about our easy-to-use financing option through Affirm. As low as 0% APR.',
        pageType: 'logistics and policies',
        breadcrumbs: [{
            label: 'Home',
            href: '/',
        },
        {
            label: 'Financing'
        }]
    }

    try {
        pageData.faqList = await getFaqsList('affirm-faq-list', getPrismicRef(req))
    } catch (error) {
        pageData.faqList = []
        console.log(error)
    }

    return {
        props: buildServerSideProps(pageData, res.locals)
    }
})

export function getServerSideProps(context) {
    const { req, res } = buildServerSideContext(context)
    return router.run(req, res)
}

export default function FinancingPage(props) {
    return (
        <FinancingView {...props} />
    )
}
